<template>
    <div style="white-space: nowrap;">
        <template v-for="n in Math.floor(stars_data)">
            <font-awesome-icon icon="star" />
        </template>
        <template v-if="!Number.isInteger(stars_data)">
            <font-awesome-icon icon="star-half-alt" />
        </template>
        <template v-for="n in Math.floor(total_stars_data - stars_data)">
            <font-awesome-icon :icon="['far', 'star']" />
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                stars_data: this.stars,
                total_stars_data: this.total_stars,
            }
        },
        props: {
            stars: {
                required: true
            },
            total_stars: {
                required: false,
                default: 5
            }
        },
        created() {
            this.stars_data       = Number(this.stars);
            this.total_stars_data = Number(this.total_stars);
        }
    }
</script>

<style scoped>

</style>